<div class="oauth-login-form" >
  <div class="row-login row">
    <div class="col-xs-12 col-sm-8 col-md-6 login-left">
      <div *ngIf="!emailNotFound;else emailNotFoundTemplate" class="flex-column" style="padding: 15px">
        <!--logo section -->
        <div class="row">
          <div class="container-fluid">
            <div class="login-header text-center">
              <img
                [src]="this.logoPath"
                class="logo"
                alt="able+"
                title="able+"
              />
              <h3 class="title hidden">able+</h3>
            </div>
          </div>
        </div>
        <!--logo section end-->
        <form
          class="margin-top-base"
          name="form"
          (keydown.enter)="handleLoginEvents(f.form.valid)"
          #f="ngForm"
        >

          <ng-container >
            <ng-container *ngTemplateOutlet="inputUserName; context: {$implicit: loginModel, form: f}"></ng-container>
            <div class="row flex-row justify-content-center" >
              <div class="input-group  col-md-11 col-lg-10 col-sm-11 col-xs-11">
              <!-- <span class="input-group-addon">
                <i class="material-icons">lock</i>
              </span> -->
                <div
                  class="form-group label-floating"
                  [ngClass]="{ 'has-error': f?.submitted && !password.valid, 'is-empty': password == '' }"
                >
                  <label class="control-label">Password</label>
                  <input
                    [type]="passwordInputType"
                    class="form-control"
                    name="password"
                    [(ngModel)]="loginModel.password"
                    #password="ngModel"
                    required
                  />
                  <span
                    *ngIf="passwordMode"
                    title="Show password"
                    class="input-group-addon addon-right text-gray cursor-pointer"
                    (click)="changePasswordMode(false)"
                  >
                  <i class="mdi mdi-eye"></i>
                </span>
                  <span
                    *ngIf="!passwordMode"
                    title="Hide password"
                    class="input-group-addon addon-right text-gray cursor-pointer"
                    (click)="changePasswordMode(true)"
                  >
                  <i class="mdi mdi-eye-off"></i>
                </span>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- <ng-container *ngIf="!userNameValidated">
            <ng-container *ngTemplateOutlet="inputUserName; context: {$implicit: loginModel, form: f}"></ng-container>
          </ng-container> -->
          <div class="flex-row justify-content-center">
            <div
              class="text-center margin-top-base padding-top-base  col-md-6 col-lg-6 col-sm-6 col-xs-11" >
              <button
                type="button"
                (click)="f.form.valid && handleLoginEvents(f.form.valid)"
                (keydown.enter)="f.form.valid && handleLoginEvents(f.form.valid)"
                [disabled]="loading || !f.form.valid"
                class="btn btn-primary btn-block"
                [ngStyle]="{ 'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value}"
              >
                Submit
              </button>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="container-fluid">
            <div class="margin-top-base flex-row justify-content-center align-items-center">
              <h4 class="title margin-right-base padding-top-base">Powered by </h4>

              <img
                [src]="ableLogoPath"
                [height]="32"
                [width]="75"
                alt="able+"
                title="able+"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emailNotFoundTemplate >
  <div class="padding-all-base  flex column">

    <div class="row flex-row justify-content-center  " >
      <label  class="text-center h6">You do not have access to this application.<br/> Please contact an administrator.</label>
    </div>
              <div class="flex-row justify-content-center">
            <div
              class="text-center  col-md-6 col-lg-6 col-sm-6 col-xs-11" >
              <button
                type="button"
                (click)="onLoginReset()"
                class="btn btn-primary btn-block"
                [ngStyle]="{ 'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value}"
              >
                Try again
              </button>
            </div>
          </div>
  </div>
</ng-template>

<ng-template #inputUserName let-passedModel let-form = "form" >
  <div class="row  flex-row justify-content-center" >
    <div class="input-group  col-md-11 col-lg-10 col-sm-11 col-xs-11">
        <!-- <span class="input-group-addon">
          <i class="material-icons">account_box</i>
        </span> -->
      <div
        class="form-group label-floating is-empty"
        [ngClass]="{'has-error': f?.submitted && !username.valid, 'is-empty': username == ''}"
      >
        <label class="control-label">Email adddress</label>
        <input
          type="text"
          class="form-control"
          name="username"
          [(ngModel)]="passedModel.username"
          #username="ngModel"
          required
        />
      </div>
    </div>
  </div>
</ng-template>
